class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.collections = this.querySelectorAll('[data-main-search-collection]');
    this.form = this.querySelector('form');
    this.setupEventListeners();
    this.setupCollectionTabs();
    this.setupFormSubmission();
    this.checkActiveTag();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // dataLayer: gnb 카테고리 탭 라벨 반환
  getGnbLabel() {
    var activeTab = this.querySelector('[data-main-search-collection].active');
    return activeTab ? activeTab.textContent.trim() : '전체';
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  setupCollectionTabs() {
    if (this.collections.length === 0) return;

    this.collections[0].classList.add('active');
    this.currentCollection = this.collections[0].dataset.mainSearchCollection;

    this.collections.forEach(col => {
      col.addEventListener('click', () => {
        const clickedCollection = col.dataset.mainSearchCollection;

        // 이미 선택된 탭이면 아무것도 하지 않음
        if (this.currentCollection === clickedCollection) return;

        this.collections.forEach(c => c.classList.remove('active'));
        col.classList.add('active');
        this.currentCollection = clickedCollection;

        // 탭 클릭 시 검색어가 있을 때만 검색 실행
        const term = this.input?.value.trim() || '';
        if (term) {
          if (window.searchController) {
            // SearchController에 위임 (AJAX, 페이지 리로드 없음)
            window.searchController.handleCategoryChange(clickedCollection);
          } else {
            // 폴백: 기존 페이지 네비게이션
            this.executeSearch();
          }
        }
      });
    });
  }

  executeSearch() {
    const term = this.input?.value.trim() || '';
    const urlParams = new URLSearchParams(window.location.search);
    const currentTerm = urlParams.get('q') || '';

    const searchUrl = '/search';
    let url = searchUrl;

    if (this.currentCollection && this.currentCollection !== 'all') {
      const tagParam = encodeURIComponent(this.currentCollection);
      url += `?filter.p.tag=${tagParam}`;

      if (term || currentTerm) {
        url += `&q=${encodeURIComponent(term || currentTerm)}`;
      } else {
        url += `&q=*`;
      }
    } else {
      // All 탭 선택 시 필터 없이 검색
      if (term || currentTerm) {
        url += `?q=${encodeURIComponent(term || currentTerm)}`;
      } else {
        url += `?q=*`;
      }
    }

    this.showLoading();
    window.location.href = url;
  }

  showLoading() {
    let overlay = this.querySelector('[data-search-loading]') || document.querySelector('[data-search-loading]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'search-loading-overlay';
      overlay.setAttribute('data-search-loading', '');
      overlay.innerHTML = '<div class="search-loading-overlay__spinner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="80" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 22 22" to="360 22 22" dur="0.75s" repeatCount="indefinite"/></circle></svg></div>';
    }
    document.body.appendChild(overlay);
    overlay.style.display = '';
  }

  setupFormSubmission() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      let term = this.input.value.trim();

      // dataLayer: search_keyword (search_keyword / gnb_search)
      if (typeof FilaDL !== 'undefined' && term) {
        var dlType = (this.currentCollection && this.currentCollection !== 'all') ? 'gnb_search' : 'search_keyword';
        FilaDL.push({ event: 'search_keyword', keyword: term, type: dlType, gnb: this.getGnbLabel() });
      }

      if (window.searchController) {
        // SearchController에 위임 (인페이지 검색)
        e.preventDefault();
        window.searchController.handleKeywordChange(term, this.currentCollection);
      } else if (this.currentCollection && this.currentCollection !== 'all') {
        // 폴백: 기존 동작
        e.preventDefault();

        const searchUrl = '/search';
        const tagParam = encodeURIComponent(this.currentCollection);
        let url = `${searchUrl}?filter.p.tag=${tagParam}`;

        if (term) {
          const searchParam = encodeURIComponent(term);
          url += `&q=${searchParam}`;
        } else {
          url += `&q=*`;
        }

        this.showLoading();
        window.location.href = url;
      } else {
        this.showLoading();
      }
    });
  }

  checkActiveTag() {
    const urlParams = new URLSearchParams(window.location.search);
    const activeTag = urlParams.get('filter.p.tag');

    if (activeTag && this.collections.length > 0) {
      const decodedTag = decodeURIComponent(activeTag).toLowerCase();

      this.collections.forEach(col => {
        const collectionTag = col.dataset.mainSearchCollection?.toLowerCase();
        if (collectionTag === decodedTag) {
          this.collections.forEach(c => c.classList.remove('active'));
          col.classList.add('active');
          this.currentCollection = col.dataset.mainSearchCollection;
        }
      });
    }
  }
}

customElements.define('main-search', MainSearch);
